import React, { useState } from "react";
import { useDispatch } from "react-redux";
import BrandsRowDetails from "./BrandsRowDetails";
import { updateBrandById } from "../../../../redux/reducer/brandReducer";
import EditBrandForm from "./EditBrandForm";

const BrandsTableDetails = ({
  details,
  onDelete,
  onUpdate,
  isEditing,
  setEditingOrder,
  onCheckboxChange,
  isSelected,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [editForm, setEditForm] = useState({
    nameEn: details.nameEN || "",
    nameAr: details.nameAR || "",
    area: details.area || "",
    category: details.category || "",
    subCategory: details.subCategory || "",
    link: details.link || "",
    desc: details.desc || "",
    image: null,
  });
  // console.log(editForm)
  const handleEdit = () => {
    setEditingOrder(details.id);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setEditForm((prev) => ({ ...prev, image: e.target.files[0] }));
  };

  const handleEditSubmit = async (data, e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);

      await dispatch(updateBrandById({ id: details.id, data })).unwrap();
      onUpdate();
      setEditingOrder(null);
    } catch (err) {
      console.error("Failed to update brand", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getLinkButton = (url) => {
    try {
      const hostname = new URL(url).hostname;
      const parts = hostname.split(".");
      const text = parts[1] || hostname;
      return (
        <button
          onClick={() => window.open(url, "_blank")}
          className="px-2 py-1 font-bold text-black duration-300 rounded bg-custom-yellow hover:bg-yellow-200"
        >
          {text}
        </button>
      );
    } catch {
      return "Invalid Link";
    }
  };
  // console.log(editForm)
  return (
    <>
      <BrandsRowDetails
        details={details}
        onDelete={onDelete}
        onEdit={handleEdit}
        getLinkButton={getLinkButton}
        onCheckboxChange={onCheckboxChange}
        isSelected={isSelected}
      />
      {isEditing && (
        <tr>
          <td colSpan="100%">
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
              <EditBrandForm
                editForm={editForm}
                onChange={handleEditChange}
                onFileChange={handleFileChange}
                onSubmit={handleEditSubmit}
                onCancel={() => setEditingOrder(null)}
                isLoading={isSubmitting}
              />
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default BrandsTableDetails;
